import { FormFieldTypes } from "../../../data/formFieldType";
import { GridColumnType } from "../../../data/gridColumnType";

export const AddManualAttendanceListData = {
  name: "AddManualAttendanceFormData",
  initialState: {
    courseId: null,
    eventId: null,
  },
  formFields: [
    {
      id: "courseId",
      lable: "Course Provider",
      Field_Name: "Course Provider",
      fieldType: FormFieldTypes.SELECT,
      dataField: "courseId",
      fieldSetting: {
        placeholder: "",
        options: [],
      },
      style: {
        containerCss: "col-lg-6 mb-2",
      },
    },
    {
      id: "eventId",
      lable: "Event",
      Field_Name: "Event",
      fieldType: FormFieldTypes.SELECT,
      dataField: "eventId",
      fieldSetting: {
        placeholder: "",
        options: [],
      },
      style: {
        containerCss: "col-lg-6 mb-2",
      },
    },
  ],
  formSetting: {
    isViewOnly: false,
  },
};

export const AddManualAttendanceTableData = {
  columns: [

    {
      name: "GMP No.",
      fieldName: "gmpNumber",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "GMP Name",
      fieldName: "gmpName",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Actions",
      fieldName: "Actions",
      allowShort: false,
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: false,
        allowDelete: true
      }
    },
  ],
};

// export const AddManualAttendanceData = {
//   name: "AddManualAttendanceData",
//   initialState: {
//     gmpNumber: '',
//     gmpName: '',
//   },
//   formFields: [
//     {
//       id: "gmpNumber",
//       lable: "GMP Number",
//       Field_Name: "GMP Number",
//       fieldType: FormFieldTypes.INPUT,
//       dataField: "gmpNumber",
//       fieldSetting: {
//         placeholder: "",
//         options: [],
//         isDisable: false,
//       },
//       validation: [{ type: "require" }],
//       style: {
//         containerCss: "col-md-10 mb-3",
//       },
//     },
//     {
//       id: "searchButtonCard",
//       fieldType: FormFieldTypes.COMPONENT,
//       additionalComponent: <SearchButtonCard />,
//       style: {
//         containerCss: "col-md-2 d-flex align-items-end mb-3",
//       }
//     },
//     {
//       id: "gmpName",
//       lable: "GMP Name",
//       Field_Name: "GMP Name",
//       fieldType: FormFieldTypes.INPUT,
//       dataField: "gmpName",
//       fieldSetting: {
//         placeholder: "",
//         options: [],
//         isDisable: false,
//       },
//       validation: [{ type: "require" }],
//       style: {
//         containerCss: "col-md-12 mb-3",
//       },
//     },
//   ],
//   formSetting: {
//     isViewOnly: false,
//   },
// };